// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__zy0ux","inputWrapper":"style_inputWrapper__1Lu96","buttonWrapper":"style_buttonWrapper__2FFvG","buttonSecondary":"style_buttonSecondary__2IR1B"};